import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';


const insertionsort = async (a, delayController) => {
  let i = 1;
  while (i < a.length) {
    let j = i;
    while (j > 0 && a[j-1] > a[j]) {
      swap(a, j, j -1);
      j -= 1;
      await delayController.delay();
    }
    i += 1;
  }
}

export default class InsertionSortAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort = async (a) => {
    await insertionsort(a, this.delayController)
    console.log('done insertion sort')
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/insertionsort.js